module.exports = __webpack_public_path__ + "img/lms-dashboard-student.0b424436.png";